// @flow
import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import { SP_USER_COMMIT_DETAILS_CONFIG_MAP } from '@streaming-projects/user-commit-details/config';
import { DateField } from '@src/formik-utils/FormFields';

import { SPUserCommitDateChangeModal } from './SPUserCommitDateChangeModal';

export const SPUserCommitEndDateContainer = ({
  disableOnFormErrors = null,
  showWarningOnChange = true,
}) => {
  const { values, initialValues } = useFormikContext();
  const [isDateChangeWarningModalOpen, setDateChangeWarningModalOpen] = useState(false);

  const { backendFieldName, displayName } = SP_USER_COMMIT_DETAILS_CONFIG_MAP.get(
    BACKEND_FIELDNAMES.COMMIT_END_DATE
  );

  return (
    <>
      {showWarningOnChange && (
        <SPUserCommitDateChangeModal
          isOpen={isDateChangeWarningModalOpen}
          setOpen={setDateChangeWarningModalOpen}
        />
      )}
      <DateField
        disableOnFormErrors={disableOnFormErrors}
        fieldDisplayName={displayName}
        fieldName={backendFieldName}
        minDate={values.start_date}
        onChange={(event, value) => {
          if (showWarningOnChange && value !== initialValues.end_date) {
            setDateChangeWarningModalOpen(true);
          }
        }}
      />
    </>
  );
};
